// extracted by mini-css-extract-plugin
module.exports = {"component_overlay":"dialog_component_overlay__W_666","component_content":"dialog_component_content__2Bfu3","component_close":"dialog_component_close__Rif0G"};